import React, { useState, SyntheticEvent } from 'react';
import { Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import AIGeneratedTag from '@op/components/AIGeneratedTag';
import { goToFeedsReviewsDetail, openWindowUrl } from '@op/utils/url';

import EditConfirmPopup from '@/pages/opinion/pages/feeds/components/EditConfirmPopup/index';
import TranslateEditPopup from '@/pages/opinion/pages/feeds/components/TranslateEditPopup/index';

import { useHistory, useIntl } from 'umi';
import './index.scss';
import DboExpandCollapseText from '../ExpandCollapse';
import UpdateSentimentInfoBox from '../SentimentEditBox';
import { getLogValue } from '@op/pages/feeds/hooks/useFeedsRequest';
import { buriedTableBtnPoint } from '@op/operationLog/buriedPoint';
import { SentimentType } from '@op/types/common';
import { DBO_GAME, DBO_T, DBO_U } from '@op/utils/format';
import { JumpType } from '@home/utils/utils';

export default function ReviewBox({
  data,
  username,
  content,
  languageType,
  link,
  editable = false,
  language,
  filter,
  sentiment,
  languageTitle,
  editTranslate,
  originContent,
  columnsIsFirst,
  logCommentMap,
  logLoading,
  logBtnId = '',
  gameInfo,
  detailParams = {},
  isSocialMedia = false,
}: any) {
  const { formatMessage } = useIntl();
  const [editVisible, setEditVisible] = useState(false);
  const [transVisible, setTransVisible] = useState(false);
  const history = useHistory();
  const goToReviews = () => {
    // if (isMoveMouse.current) return;
    const { location: hookLocation } = history;
    const { pathname } = hookLocation || {};
    const { search } = window.location;

    const query = DBO_U.queryObj(search);
    const commonParams = {
      language,
      redirect_path: encodeURIComponent(DBO_U.stripBasePath(pathname + search)),
      ...detailParams,
      gameid: gameInfo?.edition_unified_id || query.gameid,
    };

    goToFeedsReviewsDetail(history, data, commonParams, JumpType.Window);
  };

  let EditableBlock = null;
  if (editable) {
    EditableBlock = (
      <Bubble
        closeOnScroll
        content={formatMessage({ id: 'Edit translation' })}
        dark
      >
        <span
          className="reviewbox-tools-icon"
          onClick={(e: SyntheticEvent) => {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            setTransVisible(true);
          }}
        >
          <SvgIcon type="pencil-m" />
        </span>
      </Bubble>
    );
  }

  let LinkBlock = null;
  if (columnsIsFirst) {
    const realLink = DBO_U.isUrl(link) ? link : '';
    const noURLTips =
      data?.comment_parent_id === '-1' && isSocialMedia
        ? 'This post has no URL'
        : 'This review has no url';

    LinkBlock = (
      <Bubble
        closeOnScroll
        content={formatMessage({
          id: realLink ? 'Go to original post' : noURLTips,
        })}
        dark
      >
        <span
          className={`reviewbox-tools-icon ${realLink ? '' : 'disabled'}`}
          onClick={(e) => {
            e.stopPropagation();
            buriedTableBtnPoint(logBtnId, 'GoToURL', data.comment_uin);
            openWindowUrl(realLink);
          }}
        >
          <SvgIcon type="other-share-icon" />
        </span>
      </Bubble>
    );
  }

  const CopyBlock = (
    <Bubble closeOnScroll content={formatMessage({ id: 'Copy review' })} dark>
      <span
        className="reviewbox-tools-icon"
        onClick={(e) => {
          e.stopPropagation();
          buriedTableBtnPoint(logBtnId, 'CopyReview', data.comment_uin);
          DBO_T.copyText(editTranslate, formatMessage);
        }}
      >
        <SvgIcon type="copy-new" />
      </span>
    </Bubble>
  );

  const DetailIconBlock = (
    <Bubble closeOnScroll content={formatMessage({ id: 'View details' })} dark>
      <span
        className="reviewbox-tools-icon"
        onClick={(e) => {
          e.stopPropagation();
          buriedTableBtnPoint(logBtnId, 'ViewDetails', data.comment_uin);
          goToReviews();
        }}
      >
        <SvgIcon type="view-details-icon" />
      </span>
    </Bubble>
  );

  let UserSentimentBlock = null;
  if (columnsIsFirst) {
    UserSentimentBlock = (
      <div className="reviewbox-userbox">
        <UpdateSentimentInfoBox
          data={data}
          needRequest={false}
          realValue={
            getLogValue(
              logCommentMap,
              data,
              'latest_sentiment',
            ) as SentimentType
          }
          sentimentLoading={logLoading}
        ></UpdateSentimentInfoBox>
        <span className="reviewbox-username">
          {username}
          {data?.aigc === 1 && <AIGeneratedTag />}
        </span>
      </div>
    );
  }

  return (
    <div className="dbo-reviewbox">
      <div className="dbo-reviewbox-hd">
        {UserSentimentBlock}
        <div className="reviewbox-tools">
          {DetailIconBlock}
          {LinkBlock}
          {EditableBlock}
          {CopyBlock}
        </div>
      </div>
      <div className="dbo-reviewbox-bd">
        <div className="dbo-reviewbox-wrapper">
          <DboExpandCollapseText
            noHtml
            className="reviewbox-content"
            text={content}
            rowNum={2}
          />
        </div>
      </div>

      {transVisible && (
        <TranslateEditPopup
          visible={transVisible}
          close={() => setTransVisible(!transVisible)}
          editTranslate={editTranslate}
          origin={originContent}
          title={languageTitle}
          filter={{ ...filter, type: languageType }}
        />
      )}

      {editVisible && (
        <EditConfirmPopup
          visible={editVisible}
          close={() => {
            setEditVisible(!editVisible);
          }}
        />
      )}

      {/* {reviewsVisible && (
        <ReviewsModal
          visible={reviewsVisible}
          data={data}
          content={content}
          language={language}
          close={() => {
            setReviewsVisible(!reviewsVisible);
          }}
        />
      )} */}
    </div>
  );
}
